'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "heading", "superheading", "subheading", "details", "condensed", "children"];
import React from 'react';
import { Details, Heading, Subheading, Superheading, Wrapper, WrapperMain } from "./index.styled.mjs";
/**
 * Use a `HeroBanner` to present a hierarchy of abridged information to a user in a simple and concise way, with
 * optional status and actions.
 */
export var HeroBanner = function HeroBanner(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'informational' : _ref$variant,
    heading = _ref.heading,
    superheading = _ref.superheading,
    subheading = _ref.subheading,
    details = _ref.details,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    children = _ref.children,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    variant: variant
  }, attributes), /*#__PURE__*/React.createElement(WrapperMain, {
    condensed: condensed
  }, /*#__PURE__*/React.createElement("hgroup", null, superheading && /*#__PURE__*/React.createElement(Superheading, null, superheading), /*#__PURE__*/React.createElement(Heading, null, heading), subheading && /*#__PURE__*/React.createElement(Subheading, null, subheading)), details && /*#__PURE__*/React.createElement(Details, null, details)), children);
};